<template>
  <div class="direction-column justify-center align-items-center">
    <div class="generating-progress">
      <div class="generating-bar" :style="{width: percent + '%'}"></div>
    </div>
    <div class="generating-text">正在生成预览...</div>
    <div class="generating-text-sub">所需时间依据文件大小不等，请耐心等待</div>
  </div>
</template>

<script>
export default {
  name: 'GenetatingStatusView',
  props: ['percent']
}
</script>

<style lang="postcss" scoped>
@import 'layout';

.generating-text {
  font-family: PingFangSC;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #252e36;
}

.generating-text-sub {
  font-family: PingFangSC;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #747b93;
}

.generating-bar {
  height: 4px;
  background-color: #6ca2ff;
}

.generating-progress {
  width: 80%;
  margin: 0 auto 20px;
  height: 4px;
  background-color: #747b93;
}
</style>
